module.exports = __webpack_public_path__ + "static/img/top.9c31eb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CloudQuickPrinting/top.png
// module id = 2zr0
// module chunks = 10